import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Linkedin, Mail } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Experience',
    href: '/experience'
  }, {
    name: 'Advisory',
    href: '/advisory'
  }];
  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy-900/80 backdrop-blur-md border-b border-navy-700/50 py-3' : 'bg-transparent py-5'}`} data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="flex justify-between items-center" data-id="element-217">
          <div className="flex-shrink-0" data-id="element-218">
            <Link to="/" onClick={handleNavClick} className="text-xl font-bold tracking-tighter text-white flex items-center gap-2" data-id="element-219">
              <span className="w-8 h-8 rounded bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center text-sm text-navy-900" data-id="element-220">
                TS
              </span>
              Tom Schrepferman
            </Link>
          </div>

          <nav className="hidden md:flex items-center space-x-8" data-id="element-221">
            {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium transition-colors ${location.pathname === link.href ? 'text-gold' : 'text-white/70 hover:text-gold'}`} data-id="element-222">
                {link.name}
              </Link>)}
            <Link to="/contact" className="px-4 py-2 rounded-md bg-gold/10 hover:bg-gold/20 text-gold text-sm font-medium transition-colors border border-gold/30" data-id="element-223">
              Contact
            </Link>
            <div className="flex items-center gap-3 ml-2" data-id="element-224">
              <a href="https://www.linkedin.com/in/tomschrepferman" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-gold transition-colors" aria-label="LinkedIn" data-id="element-225">
                <Linkedin className="w-4 h-4" data-id="element-226" />
              </a>
              <a href="mailto:tom@hyroadconsulting.com" className="text-white/50 hover:text-gold transition-colors" aria-label="Email" data-id="element-227">
                <Mail className="w-4 h-4" data-id="element-228" />
              </a>
            </div>
          </nav>

          <div className="md:hidden flex items-center" data-id="element-229">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white/70 hover:text-white focus:outline-none" data-id="element-230">
              {isMobileMenuOpen ? <X size={24} data-id="element-231" /> : <Menu size={24} data-id="element-232" />}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-navy-800 border-b border-navy-700 shadow-xl" data-id="element-233">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-234">
            {navLinks.map(link => <Link key={link.name} to={link.href} onClick={handleNavClick} className={`block px-3 py-3 text-base font-medium rounded-md ${location.pathname === link.href ? 'text-white bg-navy-700' : 'text-white/70 hover:text-white hover:bg-navy-700'}`} data-id="element-235">
                {link.name}
              </Link>)}
            <Link to="/contact" onClick={handleNavClick} className="block px-3 py-3 mt-4 text-base font-medium text-center text-navy-900 bg-gold rounded-md" data-id="element-236">
              Contact
            </Link>
          </div>
        </div>}
    </header>;
}